import { Box, Typography, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import { LinkButton } from "@/common/Styled/CommonStyled";


export const ContentsBox = styled(Stack)(() => ({
  alignItems:"center",
  padding: "32px 16px",
  gap: 16,
  '&.setting-box':{
    '& a':{
      padding: '8px 0',
    }
  },
  '& svg':{
    verticalAlign:'middle',
    marginRight:4
  }
}));

export const LineStyle = styled(Box)(() => ({
  width: "100%",
  height: 1,
  margin: "8px 0",
  background: "#F0F1F5",
}));

export const ListBox = styled(Stack)(() => ({
  width: '100%',
  gap: 8,
}));

export const TitleText = styled(Typography)(() => ({
  "&.MuiTypography-root": {
    fontSize: "1.125rem",
    color: "#333",
    fontWeight: 700,
    lineHeight: "22.4px",
  },
}));

export const PokoroSettingBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  width: '100%',
  background: '#F8F8FA',
  borderRadius: '12px',
  padding: '16px',
  boxSizing: 'border-box',
}));


export const WifiItem = styled(Stack)(() => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  background: '#fff',
  borderRadius: 8,
  padding: 8,
  color: '#222',
  cursor: 'pointer',
  '&:hover': {
    background: '#FFFCF0',
  },
}));


export const LanguageBox = styled(Box)(() => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
}));

export const StyledLinkButton = styled(LinkButton)(({ disabled }) => ({
  opacity: disabled ? 0.2 : 1,
  pointerEvents: disabled ? "none" : "auto",
}));



export const LogoutBtn = styled(Stack)(() => ({
  gap:8,
  position: 'fixed',
  bottom: 0,
  width: '100%',
  maxWidth: '700px',
  padding: '32px 16px',
  boxSizing: 'border-box',
}));